/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailTemplateLanguage } from './MailTemplateLanguage';
import {
    MailTemplateLanguageFromJSON,
    MailTemplateLanguageFromJSONTyped,
    MailTemplateLanguageToJSON,
    MailTemplateLanguageToJSONTyped,
} from './MailTemplateLanguage';

/**
 * 
 * @export
 * @interface MailboxRenderRequestDTO
 */
export interface MailboxRenderRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxRenderRequestDTO
     */
    TemplateId: string;
    /**
     * 
     * @type {MailTemplateLanguage}
     * @memberof MailboxRenderRequestDTO
     */
    Language?: MailTemplateLanguage;
    /**
     * 
     * @type {number}
     * @memberof MailboxRenderRequestDTO
     */
    ProfileId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxRenderRequestDTO
     */
    OnboardingToken?: string | null;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof MailboxRenderRequestDTO
     */
    Variables?: { [key: string]: string | null; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof MailboxRenderRequestDTO
     */
    ForEditor?: boolean;
}



/**
 * Check if a given object implements the MailboxRenderRequestDTO interface.
 */
export function instanceOfMailboxRenderRequestDTO(value: object): value is MailboxRenderRequestDTO {
    if (!('TemplateId' in value) || value['TemplateId'] === undefined) return false;
    return true;
}

export function MailboxRenderRequestDTOFromJSON(json: any): MailboxRenderRequestDTO {
    return MailboxRenderRequestDTOFromJSONTyped(json, false);
}

export function MailboxRenderRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxRenderRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'TemplateId': json['TemplateId'],
        'Language': json['Language'] == null ? undefined : MailTemplateLanguageFromJSON(json['Language']),
        'ProfileId': json['ProfileId'] == null ? undefined : json['ProfileId'],
        'OnboardingToken': json['OnboardingToken'] == null ? undefined : json['OnboardingToken'],
        'Variables': json['Variables'] == null ? undefined : json['Variables'],
        'ForEditor': json['ForEditor'] == null ? undefined : json['ForEditor'],
    };
}

export function MailboxRenderRequestDTOToJSON(json: any): MailboxRenderRequestDTO {
    return MailboxRenderRequestDTOToJSONTyped(json, false);
}

export function MailboxRenderRequestDTOToJSONTyped(value?: MailboxRenderRequestDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'TemplateId': value['TemplateId'],
        'Language': MailTemplateLanguageToJSON(value['Language']),
        'ProfileId': value['ProfileId'],
        'OnboardingToken': value['OnboardingToken'],
        'Variables': value['Variables'],
        'ForEditor': value['ForEditor'],
    };
}

